import Vue from 'vue'
import Vuex from 'vuex'
import vks from './sdk/vks-sdk'
import VuexPersistence from 'vuex-persist'

//using vue-presist plugin to avoid using localstorage without Json parsing,
//having options as localstor for vue-localstorage and reduced storage to
//selectedOptions
const vuexLocal = new VuexPersistence({
  storage: localStorage,
  reducer: (state) => ({ selectedOptions: state.selectedOptions, userInfo: state.userInfo })
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    init: false,
    nowShowingSchedule: null,
    comingSoonSchedule: null,
    subscribe: null,
    requestError: null,
    activity: null,
    userToken: null,
    items: null,
    homeData: null,
    tokenError: null,
    voucherActivity: null,
    voucherError: null,
    phoneNumError: null,
    payfortError: null,
    loggedIn: false,
    seatCampaign: null,
    campaignError: null,
    showLogoutModal: false,
    showModal: false,
    selectedOptions: null,
    displayNotification: null,
    userInfo: null,
    userCredentials: null,
    bookingActivity: null
  },
  mutations: {
    SET_INIT (state, data) {
      state.init = data
    },
    SET_HOME_DATA (state, data) {
      state.homeData = data
    },
    SET_SUBSCRIBE (state, data) {
      state.subscribe = data
    },
    SET_REQUEST_ERROR (state, data) {
      state.requestError = data
    },
    SET_ACTIVITY (state, data) {
      state.activity = data
    },
    SET_VOUCHER_ACTIVITY (state, data) {
      state.voucherActivity = data
    },
    SET_USER_TOKEN (state, data) {
      state.userToken = data
    },
    SET_LOGGEDIN(state, data) {
      state.loggedIn = data
    },
    SET_ITEMS (state, data) {
      state.items = data
    },
    SET_TOKEN_ERROR (state, data) {
      state.tokenError = data
    },
    SET_VOUCHER_ERROR (state, data) {
      state.voucherError = data
    },
    SET_PHONE_ERROR (state, data) {
      state.phoneNumError = data
    },
    SET_PAYFORT_ERROR (state, data) {
      state.payfortError = data
    },
    SET_SEATS_CAMPAIGN (state, data) {
      state.seatCampaign = data
    },
    SET_CAMPAIGN_ERROR (state, data) {
      state.campaignError = data
    },
    SET_SHOW_LOGOUT_MODAL (state, data) {
      state.showLogoutModal = data
    },
    SET_SHOW_MODAL (state, data) {
      state.showModal = data
    },
    SET_SELECTED_OPTIONS (state, data) {
      state.selectedOptions = data
    },
    SET_DISPLAY_NOTIFICATION (state, data) {
      state.displayNotification = data
    },
    SET_USER_INFO (state, data) {
      state.userInfo = data
    },
    SET_USER_CREDENTIALS (state, data) {
      state.userCredentials = data
    },
    SET_BOOKING_ACTIVITY (state, data) {
      state.bookingActivity = data
    }
  },
  actions: {
    INIT (context, opts) {
      vks.init(
        opts.domain,
        opts.outlet,
        opts.version,
        opts.opts
      ).then(function (data) {
        context.commit('SET_INIT', true)
      }, function (error) {
        context.commit('SET_REQUEST_ERROR', error)
      })
    },
    LOAD_SCHEDULE (context, name) {
      vks.request.schedule(name, {
        metadata: true
      }).playlists().then(function (data) {
        context.commit('SET_HOME_DATA', data)
      }).catch(function (error) {
        context.commit('SET_REQUEST_ERROR', error)
      })
    },
    SUBSCRIBE (context, params) {
      vks.request.subscribe(params).then(function (data) {
        context.commit('SET_SUBSCRIBE', data)
      }).catch(function (error) {
        context.commit('SET_SUBSCRIBE', error)
      })
    },
    LOAD_ITEMS (context, id) {
      vks.request.items(id).then(function (data) {
        context.commit('SET_ITEMS', data)
      }).catch(function (error) {
        context.commit('SET_REQUEST_ERROR', error)
      })
    },
    LOAD_USER_TOKEN (context, params) {
      vks.request.token(params).then(function (data) {
        context.commit('SET_USER_TOKEN', data)
      }).catch(function (error) {
        context.commit('SET_PHONE_ERROR', error)
      })
    },
    LOAD_TOKEN (context, params) {
      vks.request.token(params).then(function (data) {
        if (data.success) {
          let dataParams = {
            uParams: {
              token: data.token,
              email: params.email,
              first_name: params.first_name,
              last_name: params.last_name
            },
            pId: data.id 
          }
          vks.request.update(dataParams.uParams, dataParams.pId).then(function (data) {
            if (data.success) {
              var loginParams = {profileId: dataParams.pId, profileToken: dataParams.uParams.token, username: dataParams.uParams.first_name, lastname: dataParams.uParams.last_name}
              context.commit('SET_USER_CREDENTIALS', loginParams)
            }
          }).catch(function (error) {
            context.commit('SET_REQUEST_ERROR', error)
          })
        }
      }).catch(function (error) {
        context.commit('SET_TOKEN_ERROR', error)
      })
    },
    LOAD_PAYFORT (context, params) {
      var payParams = {
        metric: context.state.selectedOptions.selectedPlaces, 
        booking:
        {time: context.state.selectedOptions.sessionData.time,
          seats: {metric: context.state.selectedOptions.selectedPlaces * -1}},
        payment: 
        {type: 'redirect',
          return_url: window.location.origin + '/:media_id/:activity_id/confirmation',
          currency: 'USD', 
          language: 'en', 
          amount: context.state.selectedOptions.selectedPlaces * context.state.selectedOptions.sessionData.price
        }, 
        token: params.token,
        campaign_id: context.state.selectedOptions.sessionData.campaignId
      }
      vks.request.activity(params.pId, 'booking', context.state.selectedOptions.experienceId, payParams).then(function (data) {
        if (data.success) {
          context.commit('SET_ACTIVITY', data)
        }
      }).catch(function (error) {
        context.commit('SET_PAYFORT_ERROR', error)
      })
    },
    LOAD_VOUCHER (context, params) {
      var payParams = {
        metric: context.state.selectedOptions.selectedPlaces, 
        booking:
        {time: context.state.selectedOptions.sessionData.time,
          seats: {metric: context.state.selectedOptions.selectedPlaces * -1}},
        payment: 
        {type: 'inline', 
          code: params.voucherCode
        }, 
        token: params.profileToken,
        campaign_id: context.state.selectedOptions.sessionData.campaignId
      }
      vks.request.activity(params.profileId, 'booking', context.state.selectedOptions.experienceId, payParams).then(function (bookData) {
        if (bookData.success) {
          vks.request.voucher(bookData.req[bookData.req.name], bookData.req.headers).then(function (data) {
            context.commit('SET_VOUCHER_ACTIVITY', bookData)
          }).catch(function (error) {
            context.commit('SET_VOUCHER_ERROR', error)
          })
        }
      }).catch(function (error) {
        context.commit('SET_VOUCHER_ERROR', error)
      })
    },
    LOAD_SEAT_CAMPAIGN (context, params) {
      var campaignParams = {
        begin_date: params.beginDate,
        end_date: params.endDate
      }
      vks.request.campaign(params.id, params.name, campaignParams).then(function (data) {
        context.commit('SET_SEATS_CAMPAIGN', data)
      }).catch(function (error) {
        context.commit('SET_CAMPAIGN_ERROR', error)
      })
    },

    LOAD_BOOKING_ACTIVITY (context, params) {
      vks.get('/' + params.id + '/activity', {
        token: params.token
      }).then(vks.format.rows)
        .then(function (data) {
          context.commit('SET_BOOKING_ACTIVITY', data)
        }).catch(function (error) {
          context.commit('SET_BOOKING_ACTIVITY', {})
        })
    }
  },
  getters: {
    getInit (state) {
      return state.init
    },
    getNowShowingSchedule (state) {
      return state.nowShowingSchedule
    },
    getComingSoonSchedule (state) {
      return state.comingSoonSchedule
    },
    getImageUrl (state) {
      return function (uri, name) {
        return vks.getImageUrl(uri, name)
      }
    },
    getHomeData (state) {
      return state.homeData
    },
    getSubscribe (state) {
      return state.subscribe
    },
    getRequestError (state) {
      return state.requestError
    },
    getActivity (state) {
      return state.activity
    },
    getVoucherActivity (state) {
      return state.voucherActivity
    },
    getUserToken (state) {
      return state.userToken
    },
    getLoggedIn (state) {
      return state.loggedIn
    },
    getItems (state) {
      return state.items
    },
    getTokenError (state) {
      return state.tokenError
    },
    getVoucherError (state) {
      return state.voucherError
    },
    getPhoneError (state) {
      return state.phoneNumError
    },
    getSeatCampaign (state) {
      return state.seatCampaign
    },
    getCampaignError (state) {
      return state.campaignError
    },
    getPayfortError (state) {
      return state.payfortError
    },
    getShowLogoutModal (state) {
      return state.showLogoutModal
    },
    getShowModal (state) {
      return state.showModal
    },
    getSelectedOptions (state) {
      return state.selectedOptions
    },
    getDisplayNotification (state) {
      return state.displayNotification
    },
    getUserInfo (state) {
      return state.userInfo
    },
    getUserCredentials (state) {
      return state.userCredentials
    },
    getBookingActivity (state) {
      return state.bookingActivity
    }
  },
  plugins: [vuexLocal.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store.js